import { render, staticRenderFns } from "./IngredientsThreeCol.vue?vue&type=template&id=c10d3afc&scoped=true&"
import script from "./IngredientsThreeCol.vue?vue&type=script&lang=js&"
export * from "./IngredientsThreeCol.vue?vue&type=script&lang=js&"
import style0 from "./IngredientsThreeCol.vue?vue&type=style&index=0&id=c10d3afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10d3afc",
  null
  
)

export default component.exports